export default __webpack_public_path__ + "static/media/logo_prestapolis_color.b04c10df.png";